import axios from 'axios';
import { PaypayPollingResultDto, PaypayQrResultDto } from '../../../common/paypay.dto'

const paypayClient = axios.create();
paypayClient.defaults.baseURL = process.env.API_PAYPAY_URL;

const Paypay = {
  setCognitoToken: function(token: string) {
    paypayClient.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  },
  getPaypayQr: async function(data: {amount: number, orderDescription: string, clientId: string, clientSecret: string, merchantId: string, storeId: string}) : Promise<PaypayQrResultData | null> {
    try {
      const res = await paypayClient.post('/qr', data);
      if (res.data.resultInfo.code != 'SUCCESS') {
        return null;
      }
      return res.data.data;
    }
    catch(e) {
      console.log(e);
      return null;
    }
  },
  pollingPaypayPayment: async function(merchantPaymentId: string) : Promise<PaypayPollingResultDto | null> {
    try {
      const res = await paypayClient.get(`/payment/${merchantPaymentId}`);
      return res.data.data;
    }
    catch(e) {
      console.log(e);
      return null;
    }
  },
  cancelPaypayPayment: async function(merchantPaymentId: string) {
    const res = await paypayClient.delete(`/payment/${merchantPaymentId}`);
    return res.data;
  },
}

export interface PaypayResultInfo {
  code: string,
  message: string,
  codeId: string
}

export interface PaypayQrResultData {
  codeId : string ,
  url : string ,
  expiryDate : number ,
  merchantPaymentId : string ,
  amount : {
    amount : number ,
    currency : string ,
  },
  orderDescription : string ,
  codeType : string ,
  requestedAt : number,
  isAuthorization : boolean ,
  deeplink : string
}

export interface PaypayPollingResultData {
  paymentId : string | null | undefined,
  status : string ,
  acceptedAt : number,
  refunds : string | null | undefined,
  merchantPaymentId : string | null | undefined ,
  amount : any | null | undefined ,
  currency : any | null | undefined ,
  requestedAt : string ,
  storeId : string | null | undefined,
  terminalId : string | null | undefined,
  orderDescription : string | null | undefined,
  orderItems : any | null | undefined,
}

export {Paypay};